import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postLendsURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    Select,
    Progress
} from "@chakra-ui/react";
import { Separator } from "components/Separator/Separator";
import useGetMechanics from "../hooks/useGetMechanics";


function CreateLend({
    isOpen,
    onClose,
    successCallback, 
    toolData, 
}) {

    const [ selectedMechanic, setSelectedMechanic ] = useState(null);
    const [ quantity, setQuantity ] = useState("0");

    const [ invQuantity, setInvQuantity ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    let { 
        mechanics, 
        setGettingMechanics, 
        gettingMechanics, 
        gettingMechanicsReqSuccess 
    } = useGetMechanics({ page: 1, limit: 3000 });

    const postLends = async (e) => {
        e.preventDefault();

        setSubmitting(true);
        // console.log(cover);

        // console.log(description, password);
        axios.post(postLendsURL, {
            toolId: toolData ? toolData.id : undefined,
            mechanicId: selectedMechanic ? selectedMechanic.id : undefined, 
            quantity,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                setSelectedMechanic(null);
                setQuantity("0");
                setErrors([]);
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            // console.log(e.response);
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (!validator.isEmpty(quantity)) {
            setInvQuantity(!validator.isNumeric(quantity));
        }

    }, [quantity]);


    useEffect(() => {
        setGettingMechanics(true);
    }, []);


    if (!isOpen || !toolData) {
        return (<></>);
    }

    const handleSelectMechanic = (e) => {
        mechanics.forEach((c) => {
            if (c.id == e.target.value) {
                // console.log(c);
                setSelectedMechanic(c);
            }
        });
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Lend {toolData.name}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                    <Flex align="center"
                        mb="10px">
                        <Text
                        fontSize="md"
                        fontWeight="bold"
                        >
                        Available:{" "}
                        </Text>
                        <Text fontSize="md" color="gray.500" fontWeight="400">
                            {toolData.available}
                        </Text>
                    </Flex>

                    <form onSubmit={postLends}>

                        {/* Mechanics */}
                        <FormControl marginBottom="12px">
                            <FormLabel>Please Select Mechanic</FormLabel>
                            {   gettingMechanics
                                ? <Progress isIndeterminate />
                                : <Select placeholder="Select Mechanic"
                                    onChange={handleSelectMechanic}>
                                    {   mechanics.map((user) => {
                                            return <option key={`mechanic-select-${user.id}`} 
                                                value={user.id}>
                                                    { `${user.firstName} ${user.lastName}`}
                                            </option>
                                        })
                                    }
                                </Select>
                            }
                        </FormControl>

                        <FormControl >

        
                            {/* Quantity */}
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Quantity
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Enter Quantity"
                                size="md" 
                                min={1}
                                max={toolData.available}
                                isInvalid={invQuantity === true}
                                isRequired={true}
                                value={quantity} 
                                onChange={e => setQuantity(e.target.value)}
                            />

                            <Flex w="100%" flexDir="column">
                                { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                            </Flex>
                            <Button
                                fontSize="10px"
                                type="submit"
                                bg="teal.300"
                                w="100%"
                                h="45"
                                mb="20px"
                                color="white"
                                mt="0px"
                                _hover={{
                                bg: "teal.200",
                                }}
                                _active={{
                                bg: "teal.400",
                                }}
                                isDisabled={submitting 
                                    || invQuantity 
                                    || (quantity < 1) 
                                    || (quantity > parseInt(toolData.available)) 
                                    || !selectedMechanic
                                }
                            >
                                SUBMIT
                            </Button>
                        </FormControl>
                    </form>
                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default CreateLend;
